<nav class="header">
  <div class="logo-container">
    <img ngSrc="/assets/nolia/logo/logo-horizontal.png" alt="Nolia" height="31" width="132">
    <div class="logo-container-divider"></div>
    <img class="logo-container-custom" *ngIf="user_data?.users_organizations?.[0]?.logo" [ngSrc]="user_data.users_organizations[0].logo" alt="Agora Madrid Logo" height="72" width="111">
  </div>
  <div class="action-container">
    <img data-tour="search-icon" ngSrc="/assets/images/icons/icon-search.svg" alt="Icon de búsqueda" height="30" width="30" (click)="onIconClick('search')">
<!--    <img ngSrc="/assets/images/icons/icon-notification.svg" alt="Icon de notificación" height="31" width="26" (click)="onIconClick('notification')">-->
    <img ngSrc="/assets/images/icons/icon-settings.svg" alt="Icon de configuración" height="31" width="26" (click)="onIconClick('settings')">
    <img ngSrc="/assets/images/icons/icon-logout.svg" alt="Icon de logout" height="31" width="26" (click)="onIconClick('logout')">
  </div>
 <!-- <ul class="questionaries d-flex align-items-center">
    <li
      class="questionary"
      *ngFor="let questionary of questionaries; index as i"
    >
      <button
        (click)="selectQuestionary(i)"
        class="btn bg-transparent text-blue font-primary&#45;&#45;b"
        [class.active]="questionary.selected"
      >
        {{ questionary.name }}
      </button>
    </li>
  </ul>-->
<!--  <div class="toolbar d-flex align-items-center">-->
    <!-- <div class="search-form">
      <label for="search">
        <img src="/assets/images/icons/icon_lupa.svg" alt="">
      </label>
      <input name="search" id="search" class="search-input" type="text" placeholder="Buscar en la librería...">
    </div> -->
    <!--<img class="notification" src="/assets/images/icons/icon_bell.svg" alt="" />-->
<!--  </div>-->
</nav>
